import { ACTOR_TAGS } from "@/presentation/helpers/actorTags.js";

/**
 * @param {Object} k - Kaplay instance
 * @param {Object} config - { parent, cardDef, hexColor }
 */
export function actionCardVisual(k, config) {
    const { parent, cardDef } = config;
    const hexColor = cardDef ? cardDef.colorHex : "#FFFFFF";

    if (!parent) throw new Error("actionCardVisual: Le 'Parent' (Actor) est manquant.");
    if (!cardDef) throw new Error("actionCardVisual: Le 'cardDef' (Data) est manquant.");
    if (!hexColor) throw new Error("actionCardVisual: La 'hexColor' est manquante.");

    // Add card illustration
    parent.add([
        k.sprite(cardDef ? cardDef.typeId : "?"),
        k.anchor("bot"),
        k.pos(0, 15),
        k.scale(0.3),
        k.z(parent.z + 1),
        ACTOR_TAGS.ACTION_CARD_CONTENT
    ]);

    // Add Name
    parent.add([
        k.text(cardDef ? cardDef.name : "Action", { size: 22, font: "lilita" }),
        k.color(k.Color.fromHex(hexColor)),
        k.anchor("center"),
        k.pos(0, -105),
        k.z(parent.z + 1),
        ACTOR_TAGS.ACTION_CARD_CONTENT
    ]);

    // Add Description
    parent.add([
        k.text(cardDef ? cardDef.description : "Description", { size: 18, font: "nunito", width: 172, align: "center" }),
        k.color("black"),
        k.anchor("top"),
        k.pos(0, 10),
        k.z(parent.z + 1),
        ACTOR_TAGS.ACTION_CARD_CONTENT
    ]);

    // Add playable effect
    parent.add([
        k.rect(parent.width + 4, parent.height + 4, { radius: 4 }),
        k.anchor("center"),
        k.pos(0, 0),
        k.color(k.Color.fromHex(hexColor)),
        k.opacity(0),
        k.z(parent.z - 1),
        ACTOR_TAGS.ACTION_CARD_IS_PLAYABLE_EFFECT
    ]);
}